document.addEventListener('DOMContentLoaded', function() {
    const variantWrapper = document.querySelector('[data-variants]');
    const variants = JSON.parse(variantWrapper.dataset.variants);
    const sizeOptions = document.querySelectorAll('[data-handle="size"] .variant-input');
    const colourOptions = document.querySelectorAll('[data-handle="colour"] .variant-input');

    function checkVariantAvailability(variant) {
        sizeOptions.forEach(function(sizeOption) {
            const size = sizeOption.dataset.value;
            const availableOptions = variants.filter(variant => variant.options.includes(size));
            const allSoldOut = availableOptions.every(variant => variant.available === false);
            if (!allSoldOut) {
                sizeOption.querySelector('input').classList.remove('disabled');
                sizeOption.querySelector('label').classList.remove('disabled');
            }
        });
    }

    document.addEventListener('variant:change', function(evt) {
        const variant = evt.detail.variant;
        const variantSelected = document.querySelector('[data-handle="size"] .variant-input input:checked');
        if (!variantSelected) return;
        const selectedSize = variantSelected.value;
        colourOptions.forEach(function(colourOption) {
            const colour = colourOption.dataset.value;
            const colourVariant = variants.find(variant => variant.options.includes(selectedSize) && variant.options.includes(colour) );
            if (colourVariant && colourVariant.available) {  
                colourOption.querySelector('input').classList.remove('disabled');
                colourOption.querySelector('label').classList.remove('disabled');
            }
        });
            
        checkVariantAvailability(variant);
    });

    checkVariantAvailability();
});